/** Query parameters carried across navigation, from src/app/constants.ts. */
export const QUERY_PARAM_DATE = 'd';
export const QUERY_PARAM_TENANT = 't';
